
// src/PublicLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

export default function PublicLayout() {
  // If you keep a public navbar/footer, put them here.
  return (
    <>
      {/* Optional: Public-only navbar/header */}
      <Outlet />
      {/* Optional: Public-only footer */}
    </>
  );
}
